import type { ReactNode } from 'react';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';

const FONT_SIZE = '14px';
const FONT_FAMILY = 'ProximaNova,Arial,sans-serif';
const FONT_WEIGHT = '400';

// https://stackoverflow.com/questions/34204975/react-is-there-something-similar-to-node-textcontent#:~:text=const%20getNodeText%20%3D%20(,return%20%27%27%0A%20%20%7D%0A%7D
const getNodeText = (node: React.ReactNode): string => {
    if (node == null) {
        return '';
    }

    switch (typeof node) {
        case 'string':
        case 'number':
            return node.toString();
        case 'boolean':
            return '';
        case 'object': {
            if (node instanceof Array) {
                return node.map(getNodeText).join('');
            }
            if ('props' in node) {
                return getNodeText(node.props.children);
            }
            return '';
        }
        default:
            return '';
    }
};

export function isBreakingLine(
    text: ReactNode,
    containerElement: HTMLElement
): boolean {
    const textString = getNodeText(text);
    // Creating a test element for the text length
    const testElement = document.createElement('div');

    // Set the styling to match the style of the text we mimic
    testElement.style.fontSize = FONT_SIZE;
    testElement.style.fontFamily = FONT_FAMILY;
    testElement.style.fontWeight = FONT_WEIGHT;

    // Set the width of the element to match the width of the text container
    testElement.style.width = `${
        containerElement.getBoundingClientRect().width
    }px`;
    testElement.style.opacity = '0';

    // Appending to body in order to render the text
    document.body.appendChild(testElement);

    // Setting short text to have the original height value
    testElement.innerHTML = 'I';
    const originalHeight = testElement.getBoundingClientRect().height;

    // Setting the desired text and messure the height once again
    testElement.innerHTML = textString;
    const heightWithText = testElement.getBoundingClientRect().height;

    // Removing from body
    document.body.removeChild(testElement);

    return originalHeight < heightWithText;
}

export function isLottieAnimation(
    mediaPath: string | object
): mediaPath is object {
    return typeof mediaPath === 'object';
}

export function getTestIdProps({
    testId,
    testIdName,
    suffix
}: { suffix: string } & MustIncludeOneOfBasicTestIdProps) {
    return {
        testId: getTestId(testId, suffix),
        testIdName: getTestId(testIdName, suffix)
    };
}
export function getTestId(testId: string, name: string) {
    return testId ? `${testId}-${name}` : undefined;
}
